import { createSelector } from '@ngrx/store';
import { getDragonflyRecipesState } from '../reducers';

export const getRecipesSearchState = createSelector(getDragonflyRecipesState, (state) => state.search);

export const getPanelExpansion = createSelector(getRecipesSearchState, ({ panelExpanded }) => panelExpanded);

export const getRecipeTypes = createSelector(getRecipesSearchState, ({ recipeTypes }) => recipeTypes);

export const getRecipeCodes = createSelector(getRecipesSearchState, ({ recipeCodes }) => recipeCodes);

export const getSelectedRecipeName = createSelector(
  getRecipesSearchState,
  ({ selectedRecipeName }) => selectedRecipeName,
);

export const getRecipeCodesFiltered = createSelector(
  getRecipeCodes,
  getSelectedRecipeName,
  (recipeCodes, searchText) => {
    if (!recipeCodes) return [];

    const sortFn = (a: string, b: string) => a.localeCompare(b);

    if (!searchText) {
      return [...recipeCodes].sort(sortFn);
    }

    const lowerSearch = searchText.toLowerCase();

    return recipeCodes.filter((code) => code.toLowerCase().includes(lowerSearch)).sort(sortFn);
  },
);

export const getSchemas = createSelector(getRecipesSearchState, ({ schemas }) => schemas);

export const getSelectedRecipeType = createSelector(
  getRecipesSearchState,
  ({ selectedRecipeType }) => selectedRecipeType,
);

export const getDeleted = createSelector(getRecipesSearchState, ({ deleted }) => deleted);

export const getActive = createSelector(getRecipesSearchState, ({ active }) => active);

export const getStartDate = createSelector(
  getRecipesSearchState,
  ({ selectedStartDate }) => new Date(selectedStartDate),
);

export const getStartDateString = createSelector(getRecipesSearchState, ({ selectedStartDate }) => selectedStartDate);

export const showStartDateClearButton = createSelector(
  getRecipesSearchState,
  ({ selectedStartDate }) => !!selectedStartDate,
);

export const getEndDate = createSelector(getRecipesSearchState, ({ selectedEndDate }) => new Date(selectedEndDate));

export const getEndDateString = createSelector(getRecipesSearchState, ({ selectedEndDate }) => selectedEndDate);

export const showEndDateClearButton = createSelector(getRecipesSearchState, ({ selectedEndDate }) => !!selectedEndDate);

export const getSideNav = createSelector(getRecipesSearchState, ({ sideNav }) => sideNav);

export const getGridData = createSelector(getRecipesSearchState, ({ gridData }) => gridData);
